import { Alert } from "antd";
import React from "react";
import "./alert_comp.scss";
import { ModalClose } from "themes/Icon";

function AlertComp({
  onClose,
  title,
  desc,
  type = "success",
  closable,
  action,
  icon,
}) {
  return (
    <Alert
      className="alert-comp"
      message={title}
      description={desc}
      type={type}
      showIcon={icon}
      icon={<span>{icon}</span>}
      onClose={onClose}
      closable={closable}
      closeIcon={closable && <ModalClose />}
      action={action}
    />
  );
}

export default AlertComp;
